export const GRID_CONFIG = {
  desktop: { amount: 2, minWidth: 280 },
  tablet: { amount: 2, minWidth: 280 },
  mobile: { amount: 2, minWidth: 280 },
};
